export const SETUP_STEPS = [
    {
        key: 'channel_connected',
        title: 'Conectar o número',
        what: 'Cadastre a conta de WhatsApp da loja, com a organização e o número do gateway (OpenBSP).',
        why: 'Sem uma conta ativa, nenhuma mensagem entra nem sai — é a base de tudo que vem depois.',
        module: 'atendimento-canais',
        linkLabel: 'Ir para Canais de atendimento',
    },
    {
        key: 'first_inbound_message',
        title: 'Receber a primeira mensagem',
        what: 'Peça para alguém escrever para o número da loja pelo WhatsApp.',
        why: 'Confirma que o webhook está registrado certo no gateway e que o Aeris está ouvindo de verdade.',
        module: 'atendimento',
        linkLabel: 'Ir para Atendimento',
    },
    {
        key: 'agent_reply',
        title: 'Responder pelo Aeris',
        what: 'Abra a conversa que chegou e responda por aqui.',
        why: 'A resposta sai com o prefixo do nome de quem escreveu — o cliente sabe com quem está falando, mesmo com vários atendentes no mesmo número.',
        module: 'atendimento',
        linkLabel: 'Ir para Atendimento',
    },
    {
        key: 'first_queue',
        title: 'Criar a primeira fila',
        what: 'Cadastre uma fila e coloque quem atende nela.',
        why: 'Sem fila, toda conversa cai sem dono — uma fila decide quem é responsável por responder.',
        module: 'atendimento-filas',
        linkLabel: 'Ir para Filas de atendimento',
    },
    {
        key: 'contact_identified',
        title: 'Identificar clientes',
        what: 'Confirme, na conversa, quando o Aeris encontrar um cliente já cadastrado pelo número.',
        why: 'Um contato identificado abre o histórico de compras dentro da própria conversa — sem isso, é um número anônimo.',
        module: 'atendimento',
        linkLabel: 'Ir para Atendimento',
    },
    {
        key: 'template_approved',
        title: 'Aprovar um modelo',
        what: 'Cadastre um modelo e submeta à Meta — a aprovação leva alguns dias, não minutos.',
        why: 'Fora da janela de 24 horas, um modelo aprovado é a ÚNICA coisa que o Aeris pode enviar.',
        module: 'atendimento-modelos',
        linkLabel: 'Ir para Modelos',
    },
    {
        key: 'first_ticket',
        title: 'Abrir o primeiro chamado',
        what: 'Abra um chamado a partir de uma conversa, ou direto na tela de Chamados.',
        why: 'Um chamado é o atendimento que não acaba quando a conversa fecha — protocolo, situação e histórico.',
        module: 'chamados',
        linkLabel: 'Ir para Chamados',
    },
    {
        key: 'bot_enabled',
        title: 'Ligar o robô',
        what: 'Cadastre a chave de um provedor de IA e ligue o robô.',
        why: 'O robô responde primeiro dentro da janela de 24h e sabe a hora de chamar um humano.',
        module: 'atendimento-robo',
        linkLabel: 'Ir para Robô de atendimento',
    },
    {
        key: 'followup_rule',
        title: 'Criar uma regra de follow-up',
        what: 'Cadastre uma regra: "comprou X, lembrar em tanto tempo".',
        why: 'Materializa um lembrete sozinho quando a venda é concluída — ninguém precisa lembrar de lembrar.',
        module: 'crm-regras',
        linkLabel: 'Ir para Regras de follow-up',
    },
    {
        key: 'campaign_dispatched',
        title: 'Disparar uma campanha',
        what: 'Crie uma campanha, pré-visualize o segmento e inicie.',
        why: 'Alcança um grupo de clientes de uma vez — reajuste, lançamento, o que for — em ritmo controlado.',
        module: 'crm-campanhas',
        linkLabel: 'Ir para Campanhas',
    },
];
//# sourceMappingURL=setup-steps.js.map